import { types as t } from 'mobx-state-tree';

export const AbstractExplanation = t
  .model({
    type: t.maybeNull<any>(t.string),
    locatedPassage: t.maybeNull<any>(t.string),
    detailExplanation: t.maybeNull<any>(t.string),
    selectedPassage: t.maybeNull<any>(t.string),
    hasSentenceCount: t.optional(t.boolean, false),
  })
  .actions((self) => ({
    setLocatedPassage(locatedPassage: any) {
      self.locatedPassage = JSON.stringify(locatedPassage);
    },
    setHasSentencesCount(hasSentenceCount: boolean) {
      self.hasSentenceCount = hasSentenceCount;
    },
  }));
